import { Observable } from "rxjs";

import { Injectable } from "@angular/core";
import { UseCase } from "../../base";
import { AddManualLocationRequest } from "../../domain/requests/plans/add-manual-location.request";
import { MasterlocationRepository } from "../../repositories/master-location.repository";

@Injectable({ providedIn: 'root' })
export class AddManualLocationUsecase implements UseCase<AddManualLocationRequest, boolean> {

    constructor(private readonly masterPlanRepository: MasterlocationRepository) {
    }

    execute(params: AddManualLocationRequest): Observable<boolean> {
        return this.masterPlanRepository.addManualLocation(params);
    }
}